import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type GridItemAlignment = 'start' | 'center';

@Component({
    selector: 'qpx-grid-item-leading',
    template: `<ng-content />`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'flex min-w-0 flex-none empty:hidden',
        '[style.align-self]': 'align()',
        '[attr.align]': 'null',
    },
})
export class QpxGridItemLeading {
    public readonly align = input<GridItemAlignment>('start');
}
